import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  viewBox: "0 0 89 97"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--logo-primary)",
      "fill-rule": "evenodd",
      d: "M87.986 97V83.446H61.162c1.352-6.28 4.828-12.43 13.581-24.86C84.961 44.131 89 33.725 89 22.965 89 8.173 81.486 0 67.567 0 53.986 0 46.584 7.837 46.584 23.078c0 3.131.338 6.167.676 9.186h16.606c-.226-2.457-.563-6.713-.563-10.31 0-7.05 1.351-10.873 3.813-10.873 2.35 0 3.701 3.806 3.701 10.872 0 9.861-2.687 16.574-10.218 27.896-13.243 20.042-15.93 27.558-15.93 43.12V97zM19.194 12.318c4.152 0 5.39 7.612 5.39 35.62v2.457c0 28.008-1.238 35.62-5.39 35.62H17.28V12.318zM0 97h19.31c17.62 0 23.235-11.081 23.235-46.814v-2.024C42.529 12.43 36.929 1.35 19.309 1.35H0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }